<script setup lang="ts">
defineExpose({
  name: 'CheckCircleIcon',
});
</script>

<template>
  <svg
    class="CheckCircleIcon"
    width="39"
    height="39"
    viewBox="0 0 39 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.8641 27.7739L30.3141 14.3239L28.2141 12.2239L16.8641 23.5739L11.1641 17.8739L9.06411 19.9739L16.8641 27.7739ZM19.7141 38.2739C17.0808 38.2739 14.6061 37.7739 12.2901 36.7739C9.97278 35.7739 7.96411 34.4239 6.26411 32.7239C4.56411 31.0239 3.21411 29.0153 2.21411 26.6979C1.21411 24.3819 0.714111 21.9073 0.714111 19.2739C0.714111 16.6406 1.21411 14.1653 2.21411 11.8479C3.21411 9.53193 4.56411 7.52393 6.26411 5.82393C7.96411 4.12393 9.97278 2.77393 12.2901 1.77393C14.6061 0.773926 17.0808 0.273926 19.7141 0.273926C22.3474 0.273926 24.8228 0.773926 27.1401 1.77393C29.4561 2.77393 31.4641 4.12393 33.1641 5.82393C34.8641 7.52393 36.2141 9.53193 37.2141 11.8479C38.2141 14.1653 38.7141 16.6406 38.7141 19.2739C38.7141 21.9073 38.2141 24.3819 37.2141 26.6979C36.2141 29.0153 34.8641 31.0239 33.1641 32.7239C31.4641 34.4239 29.4561 35.7739 27.1401 36.7739C24.8228 37.7739 22.3474 38.2739 19.7141 38.2739ZM19.7141 35.2739C24.1474 35.2739 27.9228 33.7159 31.0401 30.5999C34.1561 27.4826 35.7141 23.7073 35.7141 19.2739C35.7141 14.8406 34.1561 11.0653 31.0401 7.94793C27.9228 4.83193 24.1474 3.27393 19.7141 3.27393C15.2808 3.27393 11.5061 4.83193 8.39011 7.94793C5.27278 11.0653 3.71411 14.8406 3.71411 19.2739C3.71411 23.7073 5.27278 27.4826 8.39011 30.5999C11.5061 33.7159 15.2808 35.2739 19.7141 35.2739Z"
      fill="#2E7B3C"
    />
  </svg>
</template>

<style lang="scss" scoped>
.CircleIcon {
  width: 100%;
  height: auto;
  fill: currentcolor;
}
</style>
